import asyncComponentLoader from "@/components/AsyncLoader";
import { ROUTES } from "@/constants";
import AssignmentsPage from "@/pages/Assignments/AssignmentsPage";
import AssignmentTaskPage from "@/pages/Assignments/AssignmentTask";
import CheckoutPage from "@/pages/Checkout";
import CheckoutAddProductsPage from "@/pages/Checkout/CheckoutAddProducts";
import OrderDetailsPage from "@/pages/Checkout/OrderDetails";
import DashboardPage from "@/pages/Dashboard";
import AddUserHRPage from "@/pages/HR/AddUser";
import TeamHRPage from "@/pages/HR/Team";
import AddMemberToTeamHRPage from "@/pages/HR/Team/AddMemberToTeam";
import MemberInfoHRPage from "@/pages/HR/Team/MemberInfo";
import AccountPage from "@/pages/Profile/Account";
import ChangePhonePage from "@/pages/Profile/ChangePhone";
import ProfilePage from "@/pages/Profile/MainInformation";
import CheckoutSVPage from "@/pages/SV/Checkout";
import MarketCreate from "@/pages/SV/MarketCreate";
import RouteManagementSVPage from "@/pages/SV/RouteManagement";
import AddMarketSVPage from "@/pages/SV/RouteManagement/AddMarket";
import RouteEditorSVPage from "@/pages/SV/RouteManagement/RouteEditor";
import TeamSVPage from "@/pages/SV/Team";
import MemberInfoSVPage from "@/pages/SV/Team/pages/MemberInfo";
import WorkPlanPage from "@/pages/WorkPlan";
import AboutPointPage from "@/pages/WorkPlan/AboutPoint";
import AddContractPage from "@/pages/WorkPlan/AboutPoint/InfoTab/AddContract";
import InfoTabContractsPage from "@/pages/WorkPlan/AboutPoint/InfoTab/InfoTabContracts";
import ContractPage from "@/pages/WorkPlan/AboutPoint/InfoTab/InfoTabContracts/Contract";
import InfoTabPlanPage from "@/pages/WorkPlan/AboutPoint/InfoTab/InfoTabPlan";
import InfoTabShelvesPage from "@/pages/WorkPlan/AboutPoint/InfoTab/InfoTabShelves";
import MarketVerifyAddress from "@/pages/WorkPlan/MarketVerifyAddress";
import ProductCardPage from "@/pages/WorkPlan/ProductCard";
import AddPhotoPage from "@/pages/WorkPlan/Tasks/AddPhoto";
import AssortmentMatrixPage from "@/pages/WorkPlan/Tasks/AssortmentMatrix";
import DMPPage from "@/pages/WorkPlan/Tasks/DMP";
import InventoryProductsPage from "@/pages/WorkPlan/Tasks/InventoryProducts";
import PromoPage from "@/pages/WorkPlan/Tasks/PromoCatalog";
import PromoTagPhotosPage from "@/pages/WorkPlan/Tasks/PromoTagPhotos";
import RejectProductsPage from "@/pages/WorkPlan/Tasks/RejectProducts";
import SalePage from "@/pages/WorkPlan/Tasks/SalePage";
import SendGeoPage from "@/pages/WorkPlan/Tasks/SendGeo";
import ShelfSizePage from "@/pages/WorkPlan/Tasks/ShelfSize";
import TakeDebtPage from "@/pages/WorkPlan/Tasks/TakeDebt";
import UnplannedMarketsPage from "@/pages/WorkPlan/Tasks/UnplannedMarkets";
import UpdateMarketInfoPage from "@/pages/WorkPlan/Tasks/UpdateMarketInfo";

import { Pages, Routes } from "./types";

const routes: Partial<Routes> = {
    [Pages.Login]: {
        component: asyncComponentLoader(
            () => import("@/pages/Authorization/Login"),
        ),
        path: "/login",
        title: "Login",
        isPrivate: false,
    },
    [Pages.ConfirmOTP]: {
        component: asyncComponentLoader(
            () => import("@/pages/Authorization/ConfirmOTP"),
        ),
        path: "/confirm-otp",
        title: "Confirm OTP",
        isPrivate: false,
    },
    [Pages.Profile]: {
        component: ProfilePage,
        path: "/profile",
        title: "Profile",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "hr", "md", "svm", "kam"],
    },
    [Pages.Account]: {
        component: AccountPage,
        path: "/profile/account",
        title: "Account",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "hr", "md", "svm", "kam"],
    },
    [Pages.ChangePhone]: {
        component: ChangePhonePage,
        path: "/profile/change-phone",
        title: "Change Phone",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },
    [Pages.Dashboard]: {
        component: DashboardPage,
        path: "/",
        title: "Dashboard",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "hr", "md", "svm", "kam"],
    },
    [Pages.MainCheckout]: {
        component: CheckoutPage,
        path: ROUTES.Checkout,
        title: "Checkout",
        isPrivate: true,
        allowedRoles: ["ta", "sv"],
    },
    // [Pages.MainCheckoutDetails]: {
    //     component: asyncComponentLoader(
    //         () => import("@/pages/Checkout/OrderDetails"),
    //     ),
    //     path: "/checkout/:id/order-details/:modifiedCurrentOrderId",
    //     title: "Checkout",
    //     isPrivate: true,
    //     allowedRoles: ["ta", "sv"],
    // },
    [Pages.MainCheckoutDetails]: {
        component: OrderDetailsPage,
        path: ROUTES.CheckoutOrderDetails,
        title: "Checkout",
        isPrivate: true,
        allowedRoles: ["ta", "sv"],
    },
    [Pages.Assignments]: {
        component: AssignmentsPage,
        path: ROUTES.AssignmentsPage,
        title: "Assignments",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "md", "ta", "kam"],
    },
    [Pages.AssignmentsTask]: {
        component: AssignmentTaskPage,
        path: ROUTES.AssignmentTask,
        title: "Assignments task",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "md", "ta", "kam"],
    },
    [Pages.DMP]: {
        component: DMPPage,
        path: ROUTES.DMP,
        title: "Install DPM",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "md", "ta", "kam"],
    },
    [Pages.PromoTagPhotos]: {
        component: PromoTagPhotosPage,
        path: ROUTES.PromoTagPhotos,
        title: "Photo of promotional price tags",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "md", "ta", "kam"],
    },
    [Pages.AssortmentMatrix]: {
        component: AssortmentMatrixPage,
        path: ROUTES.AssortmentMatrix,
        title: "Асортиментна матриця",
        isPrivate: true,
        allowedRoles: ["svm", "md", "kam"],
    },
    [Pages.WorkPlan]: {
        component: WorkPlanPage,
        path: "/work-plan",
        title: "Work Plan",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },
    [Pages.AboutPoint]: {
        component: AboutPointPage,
        path: ROUTES.MarketDetails,
        title: "Point details",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "hr", "md", "svm", "kam"],
    },
    [Pages.AboutPointVerifyAddress]: {
        component: MarketVerifyAddress,
        path: ROUTES.MarketVerifyAddress,
        title: "Verify address",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    [Pages.AboutPointContracts]: {
        component: InfoTabContractsPage,
        path: "/work-plan/details/:marketId/contracts",
        title: "Market contracts",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "hr", "svm", "md", "kam"],
    },
    [Pages.AboutPointContract]: {
        component: ContractPage,
        path: "/work-plan/details/:marketId/contracts/:contractId",
        title: "Market contract",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "hr", "svm", "md", "kam"],
    },
    [Pages.AboutPointShelves]: {
        component: InfoTabShelvesPage,
        path: "/work-plan/details/:marketId/shelves",
        title: "Market shelves",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "hr", "md", "svm", "kam"],
    },
    [Pages.AboutPointPlan]: {
        component: InfoTabPlanPage,
        path: "/work-plan/details/:marketId/plan",
        title: "Market plan",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "hr", "svm"],
    },
    [Pages.TakeDebt]: {
        component: TakeDebtPage,
        path: "/work-plan/:id/takeDebt/:taskId",
        title: "Point details",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    [Pages.Upsells]: {
        component: SalePage,
        path: "/work-plan/:id/saleAdditional/:taskId",
        title: "Upsells",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    [Pages.PromoCatalog]: {
        component: PromoPage,
        path: "/work-plan/:id/saleAdditional/:taskId/promo",
        title: "Promo",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    [Pages.CheckoutUpsells]: {
        component: CheckoutAddProductsPage,
        path: ROUTES.CheckoutAddProducts,
        title: "FAQ",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "svm"],
    },
    [Pages.ContractCreation]: {
        component: AddContractPage,
        path: "/addContract/:marketId",
        title: "AddProducts",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    [Pages.ProductCard]: {
        component: ProductCardPage,
        path: ROUTES.ProductPage,
        title: "Upsells",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "md", "svm", "kam"],
    },
    [Pages.UpdateMarketInfo]: {
        component: UpdateMarketInfoPage,
        path: ROUTES.UpdateMarketInfoTask,
        title: "Update market info",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },
    [Pages.SetGeoLocation]: {
        component: SendGeoPage,
        path: ROUTES.SetGeoLocationTask,
        title: "SetGeoLocation",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },
    [Pages.AddPhoto]: {
        component: AddPhotoPage,
        path: ROUTES.AddPhotoTask,
        title: "AddPhoto",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },
    [Pages.RemainingGoods]: {
        component: InventoryProductsPage,
        path: ROUTES.UpdateProductBalancesTask,
        title: "Inventory Products ",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    [Pages.RejectProducts]: {
        component: RejectProductsPage,
        path: ROUTES.RejectProductsTask,
        title: "Reject Products",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    [Pages.ShelfSize]: {
        component: ShelfSizePage,
        path: "/work-plan/:id/shelfSize/:taskId",
        title: "ShelfSize",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    [Pages.UnplannedMarkets]: {
        component: UnplannedMarketsPage,
        path: "/work-plan/unplanned-market",
        title: "Unplanned Markets",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },

    // SV
    [Pages.Team]: {
        component: TeamSVPage,
        path: "/team",
        title: "Team",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    [Pages.MemberInfo]: {
        component: MemberInfoSVPage,
        path: "/team/:userId",
        title: "Member",
        isPrivate: true,
        allowedRoles: ["sv", "hr", "svm"],
    },
    [Pages.RouteManagement]: {
        component: RouteManagementSVPage,
        path: ROUTES.RouteManagement,
        title: "Member",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    [Pages.NewRouteSV]: {
        component: RouteEditorSVPage,
        path: ROUTES.RouteManagementCreate,
        title: "NewRoute",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    [Pages.EditRouteSV]: {
        component: RouteEditorSVPage,
        path: ROUTES.RouteManagementEdit,
        title: "Edit Route",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    [Pages.AddMarketSV]: {
        component: AddMarketSVPage,
        path: ROUTES.RouteManagementAddMarket,
        title: "Add market",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "kam"],
    },
    [Pages.AddNewMarketSV]: {
        component: AddMarketSVPage,
        path: ROUTES.RouteManagementCreateAddMarket,
        title: "Add market",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    [Pages.RouteManagementMyRoute]: {
        component: RouteEditorSVPage,
        path: ROUTES.RouteManagementMyRoute,
        title: "Edit My Route",
        isPrivate: true,
        allowedRoles: ["kam"],
    },
    [Pages.MainCheckoutSV]: {
        component: CheckoutSVPage,
        path: "/sv-checkout",
        title: "Checkout",
        isPrivate: true,
        allowedRoles: ["sv"],
    },
    [Pages.AgentCheckoutSV]: {
        component: CheckoutPage,
        path: "/sv-checkout/:agentId",
        title: "Agent checkout",
        isPrivate: true,
        allowedRoles: ["sv"],
    },
    [Pages.MarketCreateSV]: {
        component: MarketCreate,
        path: ROUTES.NewRouteMarketCreate,
        title: "Market create",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "kam"],
    },

    // HR
    [Pages.TeamHR]: {
        component: TeamHRPage,
        path: "/team-hr",
        title: "Team",
        isPrivate: true,
        allowedRoles: ["hr"],
    },
    [Pages.MemberInfoHR]: {
        component: MemberInfoHRPage,
        path: "/team-hr/member-info/:userId/:userRole",
        title: "Member",
        isPrivate: true,
        allowedRoles: ["hr"],
    },
    [Pages.AddMemberToTeamHR]: {
        component: AddMemberToTeamHRPage,
        path: "/add-team-member/:managerId/:managerRole",
        title: "Member",
        isPrivate: true,
        allowedRoles: ["hr"],
    },
    [Pages.AddNewUserHR]: {
        component: AddUserHRPage,
        path: "/add-user-hr",
        title: "New user",
        isPrivate: true,
        allowedRoles: ["hr"],
    },
};

export default routes;
